import { withPrefix } from "gatsby"

const loadTracker = () => {
  ;(function (p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
      p.GlobalSnowplowNamespace.push(i)
      p[i] = function () {
        ;(p[i].q = p[i].q || []).push(arguments)
      }
      p[i].q = p[i].q || []
      n = l.createElement(o)
      g = l.getElementsByTagName(o)[0]
      n.async = 1
      n.src = w
      g.parentNode.insertBefore(n, g)
    }
  })(window, document, "script", withPrefix("c3AtdjQuNi41Lmpz.js"), "snowplow")

  window.snowplow(
    "newTracker",
    "sp",
    "webhooks.sliceinsurance.com/sigpro/collector",
    {
      appId:
        window.location.host === "dev-www.sliceinsurance.com" ||
        window.location.host === "stg-www.sliceinsurance.com" ||
        window.location.host.includes("localhost")
          ? "sliceinsurance.com.dev"
          : "sliceinsurance.com.prd",
      contexts: {
        webPage: true,
      },
    }
  )
}

export const trackPage = () => {
  if (!window.snowplow) loadTracker()
  window.snowplow("trackPageView")
  window.snowplow("enableLinkClickTracking")
  window.snowplow("enableFormTracking")
  window.snowplow("enableActivityTracking", {
    minimumVisitLength: 30,
    heartbeatDelay: 30,
  })
}

export const stopTracking = () => {
  document.cookie.split("; ").forEach((cookie) => {
    const name = cookie.split("=")[0]
    if (name.startsWith("_sp_")) {
      document.cookie = `${name}=; path=/; max-age=0`
    }
  })
  if (window.snowplow) window.location.reload()
}
